module.exports = __webpack_public_path__ + "static/cs@illinois-6e90365c09e39770152d7686f5cbf83e.png";